export const WEBROUTES = {
  ES_SCREEN: '/es',
  LOGIN_SCREEN: '/login',
  OTP_SCREEN: '/otp-verify',
  VENDOR_SCREEN: '/vendor',
  PAYMENT_SCREEN: '/payment',
  CUSTOMER_INVITE_LOADING_SCREEN: '/invite',
  INVOICE: '/invoice',
  INVOICE_SCREEN: '/invoices',
  PAYMENT_SUCCESS_SCREEN: '/success',
  OTP_LOCK_SCREEN: '/otp-lock',
  ADD_BANK_DETAILS_SCREEN: '/bank',
  PAYMENT_RESPONE_SCREEN: '/payment-response',
  HOME_SCREEN: '/home',
  ADD_BANK_DETAILS_RESPONSE_SCREEN: '/bank-upi-response',
  MOBILE_NUMBER_CHANGE: '/mobile-number-change',
  ERROR_SCREEN: '/error-screen',
  UNAUTHORIZED_SCREEN: '/unauthorized',
  OFFERS: '/offers',
  DOWNLOAD_RECEIPT: '/download-receipt',
  UPI_VERIFICATION_TIMER_SCREEN: '/upi-payment-verify',
  UPI_PAYMENT_OPTIONS_SCREEN: '/payment-options',
  UPI_QR_CODE_SCREEN: '/scan-qr',
  ORDER: '/order',
  MANUAL_ORDER: '/manual-order',
  REVIEW_INVOICES: '/review-invoices',
  ORDER_SUCCESSFULL: '/order-successful',
  OPPS: '/opps',
  CAMPAIGN: '/campaign',
  CATALOGUE: '/catalogue',
  PRICELIST: '/pricelist',
  GST_SCREEN: '/gst',
  KYC_SCREEN: '/kyc',
  FACEBOOK: '/campaign/lp',
  CATALOGUE_IMAGE_SEARCH: '/v2/catalogue/search/image',
  CART: '/cart',
  PRODUCT_DETAILS: '/product',
  REORDER: '/reorder',
  SURVEY_FORM: '/survey',
  CATALOG_TOOL: '/catalog-tool',
  PAYMENT_ADVICE: '/payment-advice',
  PAYMENTS: '/payments',
  PAYMENT: '/payment',
  LEDGER: '/ledger',
  DIALER_REDIRECT: '/dialer',
};
